/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Location Pin Icon component -
 * used by the Asset Summary Card's Location row (ION-7396). Distinct from
 * the existing solid-fill pin icons (EventHistoryLocationIcon) and
 * outline-style pins (MapPinIcon, SystemLocationIcon): all three draw a
 * visibly different silhouette/proportions from the Figma spec sampled for
 * this card, so none was reused as-is - flagged here for design to confirm
 * if a shared pin icon was actually intended instead.
 */
export const LocationPinIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 13 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M6.08467 0C11.3244 8.74117e-05 14.1051 6.19034 10.6237 10.1064L6.64521 14.582C6.50293 14.7418 6.29866 14.833 6.08467 14.833C5.87066 14.8329 5.66637 14.7419 5.52412 14.582L1.5456 10.1064C-1.93541 6.19037 0.845145 0.000253114 6.08467 0ZM6.08467 1.5C2.13897 1.50025 0.0455309 6.1619 2.6667 9.11035L6.08467 12.9541L9.50264 9.11035C12.1238 6.16185 10.0305 1.50009 6.08467 1.5ZM6.08467 3.33301C7.6034 3.33301 8.83458 4.5643 8.83467 6.08301C8.83467 7.60179 7.60345 8.83301 6.08467 8.83301C4.56595 8.83293 3.33467 7.60174 3.33467 6.08301C3.33475 4.56435 4.566 3.33309 6.08467 3.33301ZM6.08467 4.83301C5.39443 4.83309 4.83475 5.39277 4.83467 6.08301C4.83467 6.77332 5.39438 7.33293 6.08467 7.33301C6.77502 7.33301 7.33467 6.77336 7.33467 6.08301C7.33458 5.39273 6.77497 4.83301 6.08467 4.83301Z' fill={iconColor} />
    </svg>
  );
};

export default LocationPinIcon;
